<template>
  <div class="StockInfo pt5" v-title data-title="库虾价格">
    <div class="row align-items-center pb5">
      <span class="pr3">库虾公司</span>
      <select v-model="stockInfo.stockCompanyId" @change="changeCompany()">
        <option value="">请选择</option>
        <option v-for="ps in stockCompany" :value ="ps.id" :key="ps.id">
          {{ps.companyName}}
        </option>
      </select>
      <div class="flex-1"></div>
      <!-- <van-button type="info" plain roundsize="small">调整报价顺序</van-button> -->
      <a v-if="infoList.length>1" @click="showPopup" class="fs5">调整报价顺序</a>
    </div>
    <div v-if="!stockInfo.stockCompanyId" class="fc-danger pt5 pb5">请先选择库虾公司再进行报价</div>
    <table v-else class="table-stockinfo">
      <thead>
        <tr>
          <th>行话</th>
          <th width="145px">价格(元)</th>
          <th width="50px">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(info, infoIndex) in infoList" :key="infoIndex">
          <td>
            <select v-model="info.stockJargonId" @change="changeCate(info)" class="w100p">
              <!-- <option value="">请选择</option> -->
              <option v-for="sc in stockCategory" :value ="sc.id" :key="sc.id">
                {{sc.name}}
              </option>
            </select>
          </td>
          <td>
            <van-stepper v-model="info.stockPrice" :button-size="30"
            :step="0.5" :min="-99999" :max="99999" :input-width="60" />
          </td>
          <td><a @click="cancel(infoIndex)" class="fc-danger fs4">取消</a></td>
        </tr>
        <tr>
          <td colspan="3">
            <van-button @click="add" plain class="btn-common" type="info"><van-icon name="plus"/> 增加一栏</van-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mt5">
      <div v-if="type===1" class="row align-items-center">
        <div class="required-box">发布时间</div>
        <van-field
          @click="showTime()"
          v-model="stockInfo.publishDate"
          readonly
          class="flex-1"
          placeholder="请选择发布时间"
        />
      </div>
      <div class="row align-items-center mt3">
        <div class="required-box">备注</div>
        <van-field
          v-model="stockInfo.remark"
          class="flex-1"
          rows="2"
          autosize
          type="textarea"
          placeholder="请输入备注"
        />
      </div>
    </div>
    <div class="row justify-content-around mt10">
      <van-button @click="back" type="info" class="btn-common" plain>返回</van-button>
      <van-button @click="publish" type="info" class="btn-common">发布价格</van-button>
    </div>
    <van-popup
      v-model="popupShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <h4>调整报价顺序</h4>
      <div class="pl5 pb7 pr5">
        <div class="sort-box">
          <template v-for="(info, popupDataIndex) in popupDataList" >
            <div class="row align-items-center pt3 pb3 pl5 pr5" :key="popupDataIndex">
              <div class="flex-1 text-left">{{stockCategoryMapping[info.stockJargonId].name}}</div>
              <div class="col-6"><van-button v-if="popupDataIndex>0" @click="goUp(popupDataIndex)" type="info" plain size="small" class="pl5">点我向上&#x2b06;</van-button></div>
              <div class="col-6"><van-button v-if="popupDataIndex+1<popupDataList.length" @click="goDown(popupDataIndex)" type="info" plain size="small" class="pl5">点我向下&#x2b07;</van-button></div>
            </div>
            <div class="line" :key="'line'+popupDataIndex"></div>
          </template>
        </div>
        <div class="row justify-content-around mt10">
          <van-button @click="closePopup" type="info" class="btn-common" plain>暂不调整</van-button>
          <van-button @click="saveSort" type="info" class="btn-common">保存顺序</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="timeShow"
      position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择日期"
        @confirm="confirmTime"
        @cancel="timeShow=false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getStockCategoryOptions, getStockCompanyOptions,
  publishStock, lastStock,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';


export default Vue.extend({
  name: 'StockInfo',
  components: {},
  data() {
    return {
      loading: false,
      infoList: [{ stockCategory: '', price: 1 }],
      stockInfo: {
        stockCompanyId: '',
      },
      stockCompany: [],
      stockCategory: [],
      popupShow: false,
      popupDataList: [],
      stockCategoryMapping: {},
      timeShow: false,
      currentDate: new Date(),
      type: storage.local.get('type'),
    };
  },
  methods: {
    changeCate(item = {}) {
      // eslint-disable-next-line eqeqeq
      const list = this.infoList.filter(c => c.stockJargonId == item.stockJargonId);
      // eslint-disable-next-line eqeqeq
      const find = this.stockCategory.find(sc => sc.id == item.stockJargonId);
      if (list.length > 1) {
        this.$set(item, 'stockJargonId', '');
        this.$dialog.alert({
          message: `${find.name}已存在，不可以重复添加，请重新选择`,
        });
      }
    },
    changeCompany() {
      this.getStockInfo();
    },
    showTime() {
      this.timeShow = true;
    },
    confirmTime(val) {
      this.$set(this.stockInfo, 'publishDate', this.formatDate(val));
      this.timeShow = false;
    },
    cancel(infoIndex) {
      if (this.infoList.length < 2) {
        this.infoList = [{ stockJargonId: '', price: 1 }];
        return;
      }
      this.infoList.splice(infoIndex, 1);
    },
    add() {
      this.infoList.push({ stockJargonId: '', price: 1 });
    },
    getStockCompany() {
      sendRequest(getStockCompanyOptions).then((res = []) => {
        this.stockCompany = res;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    getStockCategory() {
      sendRequest(getStockCategoryOptions).then((res = []) => {
        this.stockCategory = res;
        const stockCategoryMapping = {};
        this.stockCategory.forEach((sc) => {
          stockCategoryMapping[sc.id] = sc;
        });
        this.stockCategoryMapping = stockCategoryMapping;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const h = date.getHours();
      const hStr = date.getHours() > 9 ? h : `0${h}`;
      const m = date.getMinutes();
      const mStr = date.getMinutes() > 9 ? m : `0${m}`;
      const datestr = `${date.getFullYear()}-${monthStr}-${dStr} ${hStr}:${mStr}:00`;
      return datestr;
    },
    getStockInfo() {
      if (!this.stockInfo.stockCompanyId) {
        return;
      }
      sendRequest(lastStock, { companyId: this.stockInfo.stockCompanyId }).then((res = {}) => {
        if (!res.stockCompanyId) {
          return;
        }
        this.infoList = res.detail || [];
        const stockInfo = res;
        stockInfo.publishDate = null;
        this.stockInfo = stockInfo;
        this.confirmTime(new Date());
      }).catch((e) => {
        this.$dialog.alert({
          message: (e || {}).message,
        });
      }).then(() => {
        // this.infoList = [];
      });
    },
    publish() {
      const infoList = this.infoList.filter(il => il.stockJargonId && il.stockPrice);
      if (infoList.length < 1) {
        this.$dialog.alert({
          message: '请至少有一行完整库虾数据',
        });
        return;
      }
      const stockInfo = JSON.parse(JSON.stringify(this.stockInfo));
      stockInfo.detail = infoList;
      sendRequest(publishStock, stockInfo).then((res) => {
        this.$dialog.alert({
          message: '发布库虾价格成功',
        });
        // this.$router.back();
        // this.back();
      }).catch((e) => {
        this.$dialog.alert({
          message: (e || {}).message || '发布库虾价格失败',
        });
      });
    },
    showPopup() {
      this.popupShow = true;
      this.popupDataList = JSON.parse(JSON.stringify(this.infoList.filter(l => l.stockJargonId)));
    },
    closePopup() {
      this.popupShow = false;
    },
    saveSort() {
      this.infoList = JSON.parse(JSON.stringify(this.popupDataList));
      this.closePopup();
    },
    goUp(popupDataIndex) {
      if (!popupDataIndex) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex - 1, 0, current[0]);
    },
    goDown(popupDataIndex) {
      if ((!popupDataIndex && popupDataIndex !== 0) || popupDataIndex + 1 >= this.popupDataList.length) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex + 1, 0, current[0]);
    },
    back() {
      const type = storage.local.get('type');
      this.$router.push(type === 1 ? '/stock/info/home' : '/home');
    },
  },
  created() {
    this.confirmTime(new Date());
    this.getStockInfo();
    this.getStockCompany();
    this.getStockCategory();
  },
});
</script>
<style scoped>
  .StockInfo {
    min-height: 100vh;
    background-color: #ffffff;
    padding: 15px 5px;
  }
  .required-box {
    width: 70px;
    font-size: 15px;
    text-align: left;
  }
  .StockInfo select {
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    min-width: 130px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    border-radius: 4px;
  }
  .StockInfo .table-stockinfo {
    width: 100%;
    border-spacing: 0;
    border-radius: 4px;
    border: 1px solid #1e67c7;
    /* border-top: 1px solid #1e67c7;
    border-left: 1px solid #1e67c7;
    border-right: 1px solid #1e67c7; */
  }
  .table-stockinfo th {
    background-color: #1e67c7;
    color: #ffffff;
    padding: 6px 0;
    /* border-bottom: 1px solid #1e67c7; */
  }
  .table-stockinfo td {
    padding: 6px 2px;
    /* border-bottom: 1px solid #1e67c7; */
  }
  .btn {
    width: 80%;
  }
  .btn-add {
    width: 40%;
  }
  .StockInfo >>> .van-stepper__input {
    font-size: 16px;
  }
  .StockInfo .stock-input {
    padding: 6px 5px;
    border-radius: 4px;
  }
  .StockInfo a {
    text-decoration: underline;
    cursor: pointer;
  }
  .StockInfo .line {
    border-top: 1px solid #dcdcdc;
  }
  .sort-box {
    min-height: 300px;
  }
  .StockInfo button {
    white-space: nowrap;
  }
</style>
